import { Component, OnInit, inject } from "@angular/core";
import { Router } from "@angular/router";
import { map, finalize } from "rxjs/operators";

import { HomeModel } from "../home.model";
import { CallEvent } from "../../shared/types";
import { PermissionsService } from "../../shared";
import { CallEventModel } from "../../call-event/call-event.model";

@Component({
	templateUrl: "call-events.component.html",
	styleUrls: ["call-events.component.scss"],
	standalone: false,
})
export class CallEventsComponent implements OnInit {
	private readonly homeModel = inject(HomeModel);
	private readonly callEventModel = inject(CallEventModel);
	private readonly router = inject(Router);
	private readonly permissionsService = inject(PermissionsService);

	callEvents$ = this.homeModel.callEvents$;

	loading$ = this.homeModel.callEvents$.pipe(map((callEvents) => !callEvents));

	refreshing = false;

	ngOnInit() {
		// @ts-expect-error TS2345
		this.callEventModel.selectFilter(undefined);
	}

	refresh() {
		this.refreshing = true;

		this.callEventModel
			.loadCallEvents()
			.pipe(
				finalize(() => {
					this.refreshing = false;
				}),
			)
			.subscribe();
	}

	showDetails(callEvent: CallEvent) {
		if (this.permissionsService.userHasPermissions(["MEDAPP.CARE.ADMINISTER_CARE"])) {
			this.router.navigate([callEvent.callId, "detail"]);
		}
	}
}
